<template>
  <div id="charts2" :style="{ width: '100%', height: '100%' }"></div>
</template>

<script>
import "echarts-liquidfill";
export default {
  props: ["chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },
  methods: {
    drawLine() {
      if (document.getElementById("charts2") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("charts2"));
      let myChart = this.$echarts.init(document.getElementById("charts2"));
      myChart.setOption({}, true);
      function Pie() {
        let dataArr = [];
        for (var i = 0; i < 150; i++) {
          if (i % 2 === 0) {
            dataArr.push({
              name: (i + 1).toString(),
              value: 50,
              itemStyle: {
                color: "#00AFFF",
                borderWidth: 0,
                borderColor: "rgba(0,0,0,0)",
              },
            });
          } else {
            dataArr.push({
              name: (i + 1).toString(),
              value: 100,
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0,
                borderColor: "rgba(0,0,0,0)",
              },
            });
          }
        }
        return dataArr;
      }
      let option = {
        series: [
          {
            // value: 50, //  内容 配合formatter
            type: "liquidFill",
            radius: "70%", // 控制中间圆球的尺寸（此处可以理解为距离外圈圆的距离控制）
            center: ["50%", "50%"],
            data: [
              0.6,
              {
                value: 0.6,
                direction: "left", //波浪方向
              },
            ], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 1,
              color: "rgba(62, 208, 255, 1)", // 球体本景色
            },
            amplitude: "6%", //波浪的振幅
            // 修改波浪颜色
            // color: ['#0286ea', 'l#0b99ff'], // 每个波浪不同颜色，颜色数组长度为对应的波浪个数
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "#6CDEFC",
                  },
                  {
                    offset: 0,
                    color: "#429BF7",
                  },
                ],
                globalCoord: false,
              },
            ],
            label: {
              formatter:
                "发电量" + "\n{d|" + this.chartsData + "}" + "\n{d|wKh}",
              rich: {
                d: {
                  fontSize: 16,
                },
              },
              fontSize: 20,
              lineHeight: 30,
              color: "#fff",
            },
            outline: {
              show: false,
            },
          },
          {
            type: "pie",
            z: 1,
            center: ["50%", "50%"],
            radius: ["82%", "83.5%"], // 控制外圈圆的粗细
            emphasis: {
              scale: false,
            },
            data: [
              {
                name: "",
                value: 500,
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: "#00AFFF",
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: "#00AFFF",
                  },
                },
              },
            ],
          },
          {
            //外发光
            type: "pie",
            z: 1,
            zlevel: -1,
            radius: ["70%", "90.5%"],
            center: ["50%", "50%"],
            emphasis: {
              scale: false,
            },
            clockwise: false,
            itemStyle: {
              borderWidth: 20,
              color: "rgba(224,242,255,1)",
            },
            label: {
              show: false,
            },
            data: [100],
          },
          {
            //底层外发光
            type: "pie",
            z: 1,
            zlevel: -2,
            radius: ["70%", "100%"],
            center: ["50%", "50%"],
            emphasis: {
              scale: false,
            },
            clockwise: false,
            itemStyle: {
              borderWidth: 20,
              color: "rgba(224,242,255,.4)",
            },
            label: {
              show: false,
            },
            data: [100],
          },
          {
            type: "pie",
            zlevel: 0,
            silent: true,
            radius: ["78%", "80%"],
            z: 1,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: Pie(),
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style>
</style>